import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {css, styled} from 'styled-components'

export const StyledDayContainer = styled(Grid)(
    ({theme: {spacing}}) => css`
        align-items: start;
        min-width: 500px;
        padding: ${spacing * 2}px 0;
    `
)
